export const REQUEST_MESSAGE_COUNT = 'REQUEST_MESSAGE_COUNT',
  REQUEST_MESSAGE_COUNT_SUCCESS = 'REQUEST_MESSAGE_COUNT_SUCCESS',
  REQUEST_MESSAGE_COUNT_ERROR = 'REQUEST_MESSAGE_COUNT_ERROR';
